import React from 'react';
import { Container } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { Layout } from 'features/common/components/Layout';
import { PrechargedServicesList } from 'features/prechargedServices/components/PrechargedServicesList';

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'left',
	},
}));

function PrechargedServicesPage(): JSX.Element {
	const classes = useStyles();

	return (
		<Layout>
			<Container component="main" maxWidth="xl">
				<div className={classes.paper}>
					<PrechargedServicesList />
				</div>
			</Container>
		</Layout>
	);
}

export default PrechargedServicesPage;
